import { render, staticRenderFns } from "./add-visit.vue?vue&type=template&id=2c853fdb&scoped=true"
import script from "./add-visit.vue?vue&type=script&lang=js"
export * from "./add-visit.vue?vue&type=script&lang=js"
import style0 from "./add-visit.vue?vue&type=style&index=0&id=2c853fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c853fdb",
  null
  
)

export default component.exports